export default "__VITE_ASSET__a1c2f1b8__"